module.exports = __webpack_public_path__ + "img/shield-icon.0ab6d71d.svg";